export default __webpack_public_path__ + "static/media/drone-broken.d1c0f4b3.png";